export default __webpack_public_path__ + "static/media/Flexi Tank2.4dc02d7b.svg";